import { Vector3, Euler } from "three";
import GraphQLSDK from "../GraphQLSDK";
import * as GQL from "../../shared/graphql/generated";

export type ObjectType = "player" | "blue-flag" | "red-flag"; // TODO combine with server

// TODO combine with server
export interface IOnlineObject {
    position: Vector3;
    rotation: Euler;
    type: ObjectType;
    id: string;
    name: string;
}

class OnlineObjects {
    public objects: IOnlineObject[] | undefined;

    constructor() {
        this.loadObjects();
    }

    public async loadObjects(): Promise<IOnlineObject[]> {
        const allObjects = await GraphQLSDK.getAllObjects();

        this.objects =
            allObjects.onlineObjects.map(OnlineObjects.deserialiseObject) || [];

        // this.subscribeToObjects();

        return this.objects;
    }

    private static deserialiseObject(
        onlineObject: GQL.OnlineObject
    ): IOnlineObject {
        return {
            ...onlineObject,
            position: new Vector3(
                onlineObject.position.x,
                onlineObject.position.y,
                onlineObject.position.z
            ),
            rotation: new Euler(
                onlineObject.rotation.x,
                onlineObject.rotation.y,
                onlineObject.rotation.z,
                "XZY"
            ),
            type: onlineObject.type as unknown as ObjectType,
            name: onlineObject.name || "Unknown Player",
        };
    }

    private async subscribeToObjects(): Promise<IOnlineObject[]> {
        // TODO ignore self
        const updatedObjects = await GraphQLSDK.subscribeToAllObjects();

        // TODO actually use updatedObjects
        // eslint-disable-next-line no-console
        console.log(updatedObjects);

        return this.objects || [];
    }

    public async getObjects(): Promise<IOnlineObject[]> {
        if (!this.objects) {
            return this.loadObjects();
        }
        return this.objects;
    }
}

export default OnlineObjects;
